import { InputBase, styled, Typography } from '@mui/material';

import palette from '../theme/palette';

export const InputText = styled(InputBase)({
  display: 'flex',
  padding: '12px 10px',
  height: '42px',
  alignItems: 'center',
  width: '100%',
  gap: '8px',
  borderRadius: '8px',
  border: `1px solid ${palette.stroke.idle}`,
  backgroundColor: palette.white
});

export const InputLabel = styled(Typography)({
  color: palette.grey[500],
  fontSize: '11px',
  fontWeight: 500
});
